<script setup lang="ts">
import { writeFile, utils } from 'xlsx';
import Button from 'primevue/button';

interface Props {
  buttonLabel?: string;
  columnsStyle: Array<any>;
  fileName: string;
  options?: object;
  mergeRules?: Array<any>;
  isAoaToSheet?: boolean;
  rowStyles?: Array<any>;
  sheets?: Array<any>;
  isExportMultiple?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  sheets: () => [],
  fileName: 'example.xlsx',
  buttonLabel: '',
  columnsStyle: () => [],
  rowStyles: () => [],
  mergeRules: () => [],
  options: () => ({
    compression: true
  })
});

const createWorksheet = (sheets: any) => {
  if (props.isExportMultiple) {
    sheets.forEach((sheetGroup: any, groupIndex: number) => {
      const workbook = utils.book_new();
      sheetGroup.forEach((sheet, index) => {
        const worksheet = props.isAoaToSheet ? utils.aoa_to_sheet(sheet.data) : utils.json_to_sheet(sheet.data);
        worksheet['!cols'] = props.columnsStyle;
        worksheet['!rows'] = props.rowStyles;
        worksheet['!merges'] = sheet.mergeRules;
        utils.book_append_sheet(workbook, worksheet, sheet.name || `Sheet ${index}`);
      });

      const fileName = props.fileName.replace('%i', `${groupIndex + 1}`);
      writeFile(workbook, fileName, props.options);
    });
  } else {
    const workbook = utils.book_new();
    sheets.forEach((sheet: any, index: number) => {
      const worksheet = props.isAoaToSheet ? utils.aoa_to_sheet(sheet.data) : utils.json_to_sheet(sheet.data);
      worksheet['!cols'] = props.columnsStyle;
      worksheet['!rows'] = props.rowStyles;
      worksheet['!merges'] = sheet.mergeRules;
      utils.book_append_sheet(workbook, worksheet, sheet.name || `Sheet ${index}`);
    });
    writeFile(workbook, props.fileName, props.options);
  }
};
</script>

<template>
  <div>
    <slot :export="createWorksheet">
      <Button type="button" icon="pi pi-external-link" :label="buttonLabel || $t('common.buttons.export')" class="p-button-primary" @click="createWorksheet(sheets)" />
    </slot>
  </div>
</template>
